// src/config/navSections.js
import {
  FaUserTie,
  FaUsers,
  FaUserCircle,
  FaMoneyBillWave,
  FaCalculator,
  FaFileInvoice,
  FaFileExcel,
  FaListUl,
  FaFileAlt,
  FaEnvelope,
  FaClipboardList, // <-- added
  FaQuestionCircle, // <-- added
} from "react-icons/fa";

import {
  Archive,
  Bot,
  CircleDollarSign,
  ClockArrowUp,
  Earth,
  FileChartColumn,
  FileChartPie,
  FileStack,
  Handshake,
  Mail,
  Receipt,
  ReceiptText,
  Warehouse,
  FileSpreadsheet,
  FileText,
} from "lucide-react";

// ---------- NAV CONFIG (sections, groups, items) ---------- //

export const NAV_SECTIONS = [
  {
    id: "operations",
    label: "عملیات تجاری",
    description: "پروفورما، ثبت سفارش و اظهارنامه‌ها",
    color: "sky",
    icon: Earth,
    groups: [
      {
        id: "issueDocuments",
        label: "صدور اسناد",
        icon: FileStack,
        items: [
          {
            to: "/invoices/new",
            label: "ایجاد اینوویس/پکینگ/گواهی مبدا",
            icon: FaFileInvoice,
          },
          {
            to: "/invoices/list",
            label: "لیست اینوویس/پکینگ/گواهی مبدا",
            icon: FaListUl,
          },
          {
            to: "/proforma-invoices/new",
            label: "ایجاد پروفورما",
            icon: FaFileInvoice,
          },
          {
            to: "/proforma-invoices/list",
            label: "لیست پروفورما",
            icon: FaListUl,
          },
        ],
      },
      {
        id: "currency",
        label: "مدیریت ارز",
        icon: CircleDollarSign,
        items: [
          {
            to: "/GetCurrencyAllocationRequests",
            label: "تخصیص ارز",
            icon: FaMoneyBillWave,
          },
          {
            to: "/currencyForm",
            label: "دریافت از سامانه",
            icon: FileSpreadsheet,
          },
          {
            to: "/PreCottageList",
            label: "تعیین منشا ارز",
            icon: FaCalculator,
          },
        ],
      },
      {
        id: "orders",
        label: "ثبت سفارش‌ها",
        icon: ClockArrowUp,
        items: [
          {
            to: "/QuotaPermitedList",
            label: "مدیریت مصرف سهمیه",
            icon: FaClipboardList,
          },
          {
            to: "/add-order",
            label: "ایجاد ثبت سفارش",
            icon: FaFileInvoice,
          },
          {
            to: "/reged-orders",
            label: "لیست ثبت سفارش‌ها",
            icon: FaListUl,
          },
          {
            to: "/import-prf",
            label: "دریافت از سامانه",
            icon: FileSpreadsheet,
            roles: ["admin"],
          },
        ],
      },
      {
        id: "declarations",
        label: "اظهارنامه‌ها",
        icon: FileChartColumn,
        items: [
          {
            to: "/expense-list",
            label: "لیست هزینه‌ها",
            icon: Receipt,
          },
          {
            to: "/cottages",
            label: "لیست اظهارنامه‌ها",
            icon: FileChartColumn,
          },
          {
            to: "/cottage-goods-list",
            label: "لیست کلی کالاها",
            icon: FileStack,
          },
          {
            to: "/decl",
            label: "دریافت از سامانه",
            icon: FileSpreadsheet,
            roles: ["admin"],
          },
        ],
      },
      {
        id: "storage",
        label: "انبارها",
        icon: Warehouse,
        items: [
          {
            to: "/storage",
            label: "کالاهای انبار",
            icon: Warehouse,
          },
          {
            to: "/storages",
            label: "تعریف انبارها",
            icon: Archive,
          },
        ],
      },
      {
        id: "exportDeclarations",
        label: "اظهارنامه‌های صادراتی",
        icon: FileChartPie,
        items: [
          {
            to: "/add-export",
            label: "ایجاد اظهارنامه صادراتی",
            icon: FaFileInvoice,
          },
          {
            to: "/export-cottages",
            label: "لیست اظهارنامه‌های صادراتی",
            icon: FaListUl,
          },
          {
            to: "/export-decl",
            label: "دریافت از سامانه",
            icon: FileSpreadsheet,
            roles: ["admin"],
          },
        ],
      },
    ],
  },
  {
    id: "parties",
    label: "طرفین",
    description: "فروشنده، خریدار و اشخاص",
    color: "amber",
    icon: Handshake,
    groups: [
      {
        id: "people",
        label: "اشخاص",
        icon: FaUsers,
        items: [
          {
            to: "/customers/new",
            label: "ایجاد شخص جدید",
            icon: FaUserCircle,
          },
          {
            to: "/customers/list",
            label: "لیست اشخاص",
            icon: FaUsers,
          },
        ],
      },
      {
        id: "parties",
        label: "طرفین فاکتور",
        icon: FaUsers,
        items: [
          {
            to: "/sellers/new",
            label: "ایجاد فروشنده",
            icon: FaUserTie,
          },
          {
            to: "/sellers/list",
            label: "لیست فروشنده‌ها",
            icon: FaListUl,
          },
          {
            to: "/buyers/new",
            label: "ایجاد خریدار",
            icon: FaUserTie,
          },
          {
            to: "/buyers/list",
            label: "لیست خریدارها",
            icon: FaListUl,
          },
        ],
      },
    ],
  },
  {
    id: "finance",
    label: "امور مالی",
    description: "چک‌ها و جریان نقدی",
    color: "emerald",
    icon: Receipt,
    groups: [
      {
        id: "checks",
        label: "چک‌ها",
        icon: ReceiptText,
        items: [
          {
            to: "/add-check",
            label: "ایجاد چک جدید",
            icon: FaFileInvoice,
          },
          {
            to: "/checks",
            label: "لیست چک‌ها",
            icon: FaListUl,
          },
          {
            to: "/check-from-excel",
            label: "ورود چک از اکسل",
            icon: FaFileExcel,
          },
        ],
      },
    ],
  },
  {
    id: "documents",
    label: "اسناد و مدارک",
    description: "وکالت‌نامه‌ها، نامه‌ها و بایگانی",
    color: "slate",
    icon: FileText,
    groups: [
      {
        id: "representations",
        label: "وکالت‌نامه‌ها",
        icon: FaEnvelope,
        items: [
          {
            to: "/add-representation",
            label: "ایجاد وکالت‌نامه",
            icon: FaFileInvoice,
          },
          {
            to: "/representations",
            label: "لیست وکالت‌نامه‌ها",
            icon: FaListUl,
          },
          {
            to: "/rep-from-excel",
            label: "ورود وکالت‌نامه",
            icon: FaFileExcel,
          },
        ],
      },
      {
        id: "letters",
        label: "نامه‌ها",
        icon: Mail,
        items: [
          {
            to: "/letterInterface",
            label: "درج نامه و سند",
            icon: FaFileInvoice,
          },
          {
            to: "/LetterList",
            label: "لیست نامه‌ها",
            icon: FaListUl,
          },
        ],
      },
      {
        id: "archive",
        label: "بایگانی",
        icon: FaFileAlt,
        items: [
          {
            to: "/documents",
            label: "بایگانی اسناد",
            icon: FaFileAlt,
          },
        ],
      },
      {
        id: "kasr",
        label: "کسر دریافتی",
        icon: FaFileAlt,
        items: [
          {
            to: "/add-kasr-daryaft",
            label: "افزودن کسر دریافتی",
            icon: FaFileAlt,
          },
          {
            to: "/kasrdaryaft-list",
            label: "لیست کسر دریافتی",
            icon: FaFileAlt,
          },
        ],
      },
    ],
  },
  {
    id: "customs",
    label: "گمرکی",
    description: "تعرفه‌ها و محاسبه حقوق گمرکی",
    color: "cyan",
    icon: Warehouse,
    groups: [
      {
        id: "tariffs",
        label: "تعرفه‌ها",
        icon: FaFileAlt,
        items: [
          {
            to: "/hscode-list",
            label: "جدول تعرفه‌ها",
            icon: FaFileAlt,
          },
          {
            to: "/hscode-inf",
            label: "لیست تعرفه‌ها",
            icon: FaListUl,
          },
        ],
      },
      {
        id: "customs-calculations",
        label: "محاسبه گمرکی",
        icon: FaCalculator,
        direct: true,
        items: [
          {
            to: "/tariff-calculator",
            label: "محاسبه گمرکی",
            icon: FaCalculator,
          },
        ],
      },
    ],
  },
  {
    id: "tools",
    label: "ابزارها و پشتیبانی",
    description: "چت‌بات، راهنما و پشتیبانی",
    color: "violet",
    icon: Bot,
    groups: [
      {
        id: "tools-main",
        label: "ابزارها",
        icon: Bot,
        items: [
          {
            to: "/chatbot",
            label: "مشاور هوش مصنوعی",
            icon: Bot,
          },
          {
            to: "/user/guide",
            label: "پشتیبانی و راهنما",
            icon: FaQuestionCircle,
          },
        ],
      },
    ],
  },
];
